import React, { Component } from 'react'
import TimeSelector from './timeSelector'
import MyCascader from './cascader'
import { Input, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import MyTable from './table'
export default class Tasklist extends Component {
    //获取数据
    render() {
        return (
            <div>
                <div className='middlePart'>
                    <div style={{display:'flex',width:'25%'}}>
                        <div className='text'>当前状态：</div>
                        <MyCascader />
                    </div>
                    <div style={{display:'flex',width:'25%'}}>
                        <div className='text'>开始时间：</div>
                        <TimeSelector />
                    </div>
                    <div style={{display:'flex',width:'25%'}}>
                        <div className='text'>结束时间：</div>
                        <TimeSelector />
                    </div>
                    <div style={{display:'flex',width:'25%'}}>
                        <Input maxLength="20" className='input' placeholder="任务名称" />
                        <Button type="primary" icon={<SearchOutlined />} iconPosition="start">
                            Search
                        </Button>
                    </div>

                </div>
                <div>
                    <MyTable />
                </div>
            </div>
        )
    }
}

